module.exports = "<span v-if=\"collaborator\">{{ formattedCollaboratorName }}</span>\n"